import React, {Component}                                       from "react";
import {Image, ImageBackground, Picker, Platform, Text, View}   from "react-native";
import {connect}                                                from "react-redux";
import {Audio, Video}                                           from "expo-av";
import ModalClues                                               from "../modals/ModalClues";
import ModalHistory                                             from "../modals/ModalHistory";
import ModalPoints                                              from "../modals/ModalPoints";
import ModalRoundEnd                                            from "../modals/ModalRoundEnd";
import ModalRoundStart                                          from "../modals/ModalRoundStart";
import NBButton                                                 from "../NBButton";
import Player                                                   from "../Player";
import RNMDropdown                                              from "../RNMDropdown";
import * as Actions                                             from "../../constants/Actions";
import styles                                                   from "../../styles/Styles";
import Countdown                                                from "../../../assets/countdown.mp4";

class ScreenGame extends Component {
    finishCountdown = (playbackStatus) => {
        if (playbackStatus.didJustFinish)
            this.props.hideCountdown();
    }

    playSoundEffect = async (correct) => {
        if (!this.props.soundEffects)
            return;

        try {
            const sound = new Audio.Sound();

            if (correct)
                await sound.loadAsync(require("../../../assets/sounds/applause.wav"));
            else
                await sound.loadAsync(require("../../../assets/sounds/cricket.wav"));

            await sound.playAsync();
        }
        catch (error) {
            console.log(error);
        }
    }
    
    selectGuess = (value) => {
        this.props.setGuess(value);
    }

    selectGuessWeb= (itemValue, itemIndex) => {
        this.props.setGuess(itemValue);
    }

    showNextClue = () => {
        if (this.props.numCluesShown < this.props.clues.length)
            this.props.showNextClue();
        else if (this.props.cluesExtra != null)
            this.props.showCluesExtra();
    }

    submitGuess = () => {
        //TODO: Code to short circuit button if no guess selected. Eventually refactor to disable button until guess selected?
        if (this.props.currentGuess == null)
            return;

        //Play sound effect and update game state
        var correct = this.props.currentGuess == this.props.answer;
        this.playSoundEffect(correct);
        this.props.submitGuess(correct);
    }

    render() {
        //Movie list
        var dropdown = null;
        if (Platform.OS === "web") {
            var listMovies = this.props.listMovies.map((movie, index) => {
                return <Picker.Item key={index} label={movie.title} value={movie.title} />
            });

            dropdown =  <Picker mode="dropdown" onValueChange={this.selectGuessWeb} prompt="Select Guess" selectedValue={this.props.currentGuess} style={styles.dropdownWeb}>
                            {listMovies}
                        </Picker>

            if (this.props.currentGuess == null)
                this.selectGuess(this.props.listMovies[0].title);
        }
        else {
            var listMovies = this.props.listMovies.map((movie, index) => ({value: movie.title}));

            dropdown = <RNMDropdown data={listMovies} label={"Select Guess"} onChangeText={(value) => this.selectGuess(value)} pickerStyle={styles.dropdownPicker}
                value={this.props.currentGuess != null ? listMovies.find(mov => mov.value == this.props.currentGuess).value : ""} />
        }

        //Create clue display
        var listActors = null;
        if (!this.props.roundStart) {
            listActors = [];
            var actors = [...this.props.clues];
            actors.reverse();
            for (var index = 0; index < actors.length; index++) {
                var clueStyle = styles.textWhite;
                var clueText = actors[index].name;
                if (index >= this.props.numCluesShown) {
                    clueStyle = styles.textTransparent;
                    clueText = "Hidden";
                }

                var actor = <Text key={index} style={clueStyle}>{clueText}</Text>;
                listActors = [actor, ...listActors];
            }

            while (listActors.length < 10) {
                var actor = <Text key={listActors.length + 1}></Text>;
                listActors = [...listActors, actor];
            }
        }
        
        var clueDisplay;
        if (this.props.enableCountdown && this.props.showCountdown)
            clueDisplay = <Video isMuted={false} onPlaybackStatusUpdate={(playbackStatus) => this.finishCountdown(playbackStatus)} rate={1.0}
                ref={this._handleVideoRef} resizeMode="cover" shouldPlay source={Countdown} style={styles.background} volume={1.0} />;
        else
            clueDisplay = 
                <View style={styles.viewClueDisplay}>
                    <Text style={styles.textWhite}>{(this.props.showAnswer && !this.props.roundStart) ? this.props.answer : ""}</Text>
                    <Text style={styles.textWhite}>Cast</Text>
                    {listActors}
                </View>;

        //Create player display
        var playerDisplay = this.props.players.map((player, index) => {
            var selected = (this.props.currentPlayer == index);
            return <Player guesses={player.guesses} icon={player.icon} key={index} name={player.name} numCorrect={player.numCorrect} score={player.score} 
                selected={selected} selectPlayer={() => {this.props.selectPlayer(index)}} swipeControls={this.props.swipeControls} />
        });

        return (
            <View style={styles.background}>
                <ImageBackground source={require("../../../assets/screen_game.png")} style={styles.background} imageStyle={styles.backgroundImageScreen} >
                    <View style={styles.background}>
                        <ModalClues />
                        <ModalHistory />
                        <ModalPoints />
                        <ModalRoundEnd />
                        <ModalRoundStart />

                        {/* Game Controls */}
                        <View style={styles.viewGameDisplay}>
                            {/* Movie guess selection and submission. */}
                            {(!this.props.enableCountdown || !this.props.showCountdown) &&
                                <View style={styles.viewGuessControls}>
                                    {dropdown}
                                    <NBButton onPress={this.submitGuess} text={"Submit"} />
                                </View>
                            }

                            {/* Clue Display */}
                            <View style={styles.viewClueDisplayBackground}>
                                <ImageBackground source={require("../../../assets/clues.png")} style={styles.backgroundClues} imageStyle={styles.backgroundImageStretch}>
                                    {clueDisplay}
                                </ImageBackground>
                            </View>

                            {/* Projector & Buttons (Play, Eject, History) */}
                            {(!this.props.enableCountdown || !this.props.showCountdown) &&
                                <View style={styles.viewGameControls}>
                                    {/* <Image source={require("../../../assets/projector.png")} /> */}
                                    <NBButton icon={"play"}     iconFamily={"FontAwesome5"} iconType={"iconLeft"} onPress={this.showNextClue}       text={"Play"} />
                                    <NBButton icon={"eject"}    iconFamily={"FontAwesome5"} iconType={"iconLeft"} onPress={this.props.eject}        text={"Eject"} />
                                    <NBButton icon={"history"}  iconFamily={"FontAwesome5"} iconType={"iconLeft"} onPress={this.props.showHistory}  text={"History"} />
                                </View>
                            }
                        </View>

                        {/* Player Display */}
                        <View style={styles.viewPlayerDisplay}>
                            {playerDisplay}
                        </View>
                    </View>
                </ImageBackground>
            </View>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        answer:             state.answer,
        category:           state.category,
        clues:              state.clues,
        cluesExtra:         state.cluesExtra,
        currentGuess:       state.currentGuess,
        currentPlayer:      state.currentPlayer,
        enableCountdown:    state.enableCountdown,
        listMovies:         state.listMovies,
        numCluesShown:      state.numCluesShown,
        numPlayers:         state.numPlayers,
        players:            state.players,
        roundEnd:           state.roundEnd,
        roundStart:         state.roundStart,
        showAnswer:         state.showAnswers,
        showCountdown:      state.showCountdown,
        soundEffects:       state.soundEffects,
        subcategory:        state.subcategory,
        swipeControls:      state.swipeControls
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        eject:          ()          => { dispatch({type: Actions.EJECT}) }, 
        hideCountdown:  ()          => { dispatch({type: Actions.HIDE_COUNTDOWN}) },
        selectPlayer:   (player)    => { dispatch({type: Actions.SELECT_PLAYER, player:     player}) },
        setGuess:       (guess)     => { dispatch({type: Actions.SET_GUESS,     guess:      guess}) },
        showCluesExtra: ()          => { dispatch({type: Actions.SHOW_CLUES_EXTRA}) },
        showHistory:    ()          => { dispatch({type: Actions.SHOW_HISTORY}) },
        showNextClue:   ()          => { dispatch({type: Actions.SHOW_NEXT_CLUE}) },
        submitGuess:    (correct)   => { dispatch({type: Actions.SUBMIT_GUESS,  correct:    correct}) }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreenGame);